/* eslint-disable dot-notation */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-string-refs */
/* eslint-disable no-restricted-globals */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
/* eslint-disable jsx-a11y/label-has-associated-control */

// @mui material components
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import React, { useEffect, useState } from "react";
import "react-dropdown/style.css";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import {
  Box,
  // TableContainer,
  Table,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  // Paper,
} from "@mui/material";
// import { useNavigate } from "react-router-dom";
// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
// import { useTranslation } from "react-i18next";
import AlertDialog from "./dialog";
// import DeleteLab from "./delete_lab";

function AddOrder() {
  // const  rows: [1];
  // const { t } = useTranslation();
  // const navigate = useNavigate();
  const [customer, setCustomer] = useState("");
  const [status0, setStatus0] = useState("");

  const [container, setContainer] = useState("");
  const [rows, setRows] = useState([0]);
  const [users, setUsers] = useState([]);
  const [statusarray, setStatusArray] = useState([]);
  const [containers, setContainers] = useState([]);
  const [usernumber, setUserNumber] = useState();
  const getUsersCustomers = async () => {
    // const token = sessionStorage.getItem("token");
    const headers = { ContentType: `application/json` };
    const response = await fetch("https://trust-cargo.co/anas_backend/api/customers", { headers });
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setUsers(data["customers"]);
    setCustomer(data["customers"][0]["code"]);
  };
  const getStatus = async () => {
    // const token = sessionStorage.getItem("token");
    const headers = { ContentType: `application/json` };
    const response = await fetch("https://trust-cargo.co/anas_backend/api/status", {
      headers,
    });
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setStatusArray(data["status"]);
  };
  const getContainers = async () => {
    // const token = sessionStorage.getItem("token");
    const headers = { ContentType: `application/json` };
    const response = await fetch("https://trust-cargo.co/anas_backend/api/containers", { headers });
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setContainers(data["containers"]);
    setContainer(data["containers"][0]["id"]);
  };
  useEffect(() => {
    getUsersCustomers();
    getContainers();
    getStatus();
  }, []);
  const [shopnumber1, setShopNumber1] = useState("");
  const [shopnumber2, setShopNumber2] = useState("");
  const [phone, setPhone] = useState("");

  const [order_number, setOrderNumber] = useState("");
  const [deliverydate, setDeliveryDate] = useState("");

  // contants of my array
  const [itemarray, setItemArray] = useState([""]);
  const [itemnumber, setItemNumber] = useState([""]);

  const [photo, setPhoto] = useState([""]);
  const [description1, setDescription1] = useState([""]);
  const [description2, setDescription2] = useState([""]);
  const [category, setCategory] = useState([""]);
  const [ctn, setCTN] = useState([""]);
  const [qtytoctn, setQtyToCtn] = useState([""]);

  const [utoprice, setUtoPrice] = useState([""]);
  const [cbm, setCBM] = useState([""]);
  // const [amount, setAmount] = useState([""]);
  // eslint-disable-next-line arrow-body-style

  const ttocbm = cbm.map((e, index) => {
    return e * ctn[index];
  });

  const total_cbm = ttocbm.reduce((e1, e2) => {
    return e1 + e2;
  });
  const total_ctn = ctn.reduce((e1, e2) => {
    return e1 + e2;
  });

  const ttoqty = ctn.map((e, index) => {
    return e * qtytoctn[index];
  });
  const amount = utoprice.map((e, index) => {
    return e * ttoqty[index];
  });

  const total_amount = amount.reduce((e1, e2) => {
    return e1 + e2;
  });
  const total_items = itemarray.reduce((e1, e2) => {
    return e1 + e2;
  });

  // const [ttocbm, setTtoCBM] = useState([""]);
  const [nw, setNW] = useState([""]);
  // const [gw, setGW] = useState([""]);
  const [status, setStatus] = useState([""]);
  const [notes, setNotes] = useState([""]);
  const gw = nw.map((e, index) => {
    return e * ctn[index];
  });
  const total_gw = gw.reduce((e1, e2) => {
    return e1 + e2;
  });

  const handleItemChange = (event, index) => {
    setItemArray((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleItemNumberChange = (event, index) => {
    setItemNumber((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handlePhotoChange = (event, index) => {
    setPhoto((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.files[0] : el;
      })
    );
  };
  const handleDescChange = (event, index) => {
    setDescription1((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleDesc2Change = (event, index) => {
    setDescription2((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleCategoryChange = (event, index) => {
    setCategory((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleCTNChange = (event, index) => {
    setCTN((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleQTYTOCTNChange = (event, index) => {
    setQtyToCtn((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  // const handleTTOQTYChange = (event, index) => {
  //   setTtoQty((state) =>
  //     state.map((el, index1) => {
  //       console.log("index1", index1);
  //       return index === index1 ? event.target.value : el;
  //     })
  //   );
  // };

  const handleUTOPriceChange = (event, index) => {
    setUtoPrice((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  // const handleAmountChange = (event, index) => {
  //   setAmount((state) =>
  //     state.map((el, index1) => {
  //       console.log("enver", event.target.value);
  //       return index === index1 ? event.target.value : el;
  //     })
  //   );
  // };
  const handleCBMChange = (event, index) => {
    setCBM((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  // const handleTTOCBMChange = (event, index) => {
  //   setTtoCBM((state) =>
  //     state.map((el, index1) => {
  //       console.log("index1", index1);
  //       return index === index1 ? event.target.value : el;
  //     })
  //   );
  // };
  const handleNWChange = (event, index) => {
    setNW((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  // const handleGWChange = (event, index) => {
  //   setGW((state) =>
  //     state.map((el, index1) => {
  //       console.log("index1", index1);
  //       return index === index1 ? event.target.value : el;
  //     })
  //   );
  // };
  const handleStatusChange = (event, index) => {
    setStatus((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleNotesChange = (event, index) => {
    setNotes((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  return (
    <DashboardLayout>
      <SuiBox py={3}>
        <SuiBox mb={3}>
          <Card>
            <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SuiTypography variant="h6">New Order</SuiTypography>
            </SuiBox>
            <div style={{ width: "1000px", margin: "20px" }}>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label className="control-label" htmlFor="name" style={{ fontSize: "15px" }}>
                      Order code
                    </label>
                    <input
                      required
                      id="shop_no1"
                      onChange={(e) => setShopNumber1(e.target.value)}
                      value={customer + shopnumber2}
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Shop code"
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label className="control-label" htmlFor="name" style={{ fontSize: "15px" }}>
                      Shop Number
                    </label>
                    <input
                      required
                      id="shop_no2"
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Shop Number"
                      onChange={(e) => setShopNumber2(e.target.value)}
                      value={shopnumber2}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label className="control-label" htmlFor="name" style={{ fontSize: "15px" }}>
                      Customer
                    </label>
                    <select
                      id="customer_id"
                      onChange={(e) => setCustomer(e.target.value)}
                      value={customer}
                      className="form-control"
                      style={{ height: "40px" }}
                    >
                      {users.map((user) => (
                        <option value={user.code}>{user.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="name"
                      style={{ fontSize: "15px", marginTop: "20px" }}
                    >
                      Phone No.
                    </label>
                    <input
                      id="phone_number"
                      required
                      onChange={(e) => setPhone(e.target.value)}
                      value={phone}
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Phone No."
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="name"
                      style={{ fontSize: "15px", marginTop: "20px" }}
                    >
                      Delivery Date
                    </label>
                    <input
                      id="delivery_date"
                      required
                      onChange={(e) => setDeliveryDate(e.target.value)}
                      value={deliverydate}
                      type="date"
                      className="form-control"
                      name="name"
                      placeholder="Delivery Date"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="name"
                      style={{ fontSize: "15px", marginTop: "20px" }}
                    >
                      Containers
                    </label>
                    <select
                      id="customer_id"
                      onChange={(e) => setContainer(e.target.value)}
                      value={container}
                      className="form-control"
                      style={{ height: "40px" }}
                    >
                      {containers.map((user) => (
                        <option value={user.id}>{user.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="name"
                      style={{ fontSize: "15px", marginTop: "20px" }}
                    >
                      Total Items
                    </label>
                    <input
                      required
                      id="shop_no2"
                      type="text"
                      className="form-control"
                      name="name"
                      readOnly
                      placeholder="Total Items"
                      // onChange={(e) => setShopNumber2(e.target.value)}
                      value={itemarray.length}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="name"
                      style={{ fontSize: "15px", marginTop: "20px" }}
                    >
                      Total Amount
                    </label>
                    <input
                      required
                      id="shop_no2"
                      type="text"
                      className="form-control"
                      name="name"
                      readOnly
                      placeholder="Total Amount"
                      // onChange={(e) => setShopNumber2(e.target.value)}
                      value={total_amount}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="name"
                      style={{ fontSize: "15px", marginTop: "20px" }}
                    >
                      Total CTN
                    </label>
                    <input
                      required
                      id="shop_no2"
                      type="text"
                      className="form-control"
                      name="name"
                      readOnly
                      placeholder="Total CTN"
                      // onChange={(e) => setShopNumber2(e.target.value)}
                      value={total_ctn}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="name"
                      style={{ fontSize: "15px", marginTop: "20px" }}
                    >
                      Total CBM
                    </label>
                    <input
                      required
                      id="shop_no2"
                      type="text"
                      className="form-control"
                      name="name"
                      readOnly
                      placeholder="Total CBM"
                      // onChange={(e) => setShopNumber2(e.target.value)}
                      value={total_cbm}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="name"
                      style={{ fontSize: "15px", marginTop: "20px" }}
                    >
                      Total GW
                    </label>
                    <input
                      required
                      id="shop_no2"
                      type="text"
                      className="form-control"
                      name="name"
                      readOnly
                      placeholder="Total GW"
                      // onChange={(e) => setShopNumber2(e.target.value)}
                      value={total_gw}
                    />
                  </div>
                </div>
              </div>

              <AlertDialog
                ItemNumber1={itemnumber}
                ItemArray={itemarray}
                photo={photo}
                desc1={description1}
                desc2={description2}
                category={category}
                ctn={ctn}
                qtytoctn={qtytoctn}
                totoqty={ttoqty}
                utoprice={utoprice}
                amount={amount}
                cbm={cbm}
                ttocbm={ttocbm}
                nw={nw}
                gw={gw}
                status={status}
                notes={notes}
                shop_number1={shopnumber1}
                shop_number2={shopnumber2}
                customer_id={customer}
                container_id={container}
                phone_number={phone}
                // order_number={`${shopnumber1}-${customer}`}
                order_number={customer + shopnumber2}
                delivery_date={deliverydate}
                total_amount1={total_amount.toString()}
              />
            </div>
          </Card>
        </SuiBox>
        <Card>
          <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
            <SuiTypography variant="h6">Items</SuiTypography>
          </SuiBox>
          <SuiBox
            sx={{
              "& .MuiTableRow-root:not(:last-child)": {
                "& td": {
                  borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                    `${borderWidth[1]} solid ${borderColor}`,
                },
              },
            }}
          >
            <Table sx={{ overflow: "scroll", display: "block" }} aria-label="simple table">
              <TableHead>
                <TableRow style={{ display: "flex" }}>
                  <Box>
                    <TableCell sx={{ width: "100px", minWidth: "100px" }} align="center">
                      S.Code{" "}
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "120px", minWidth: "120px" }} align="center">
                      Item NO.
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "150px", minWidth: "150px" }} align="center">
                      Photo
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "150px", minWidth: "150px" }} align="center">
                      Chinese
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                      Material
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                      English
                    </TableCell>
                  </Box>

                  <Box>
                    <TableCell sx={{ width: "150px", minWidth: "150px" }} align="center">
                      CTN
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "70px", minWidth: "70px" }} align="center">
                      QTY/CTN
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "70px", minWidth: "70px" }} align="center">
                      T/QTY
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "110px", minWidth: "110px" }} align="center">
                      U/Price
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "120px", minWidth: "120px" }} align="center">
                      Amount
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "60px", minWidth: "60px" }} align="center">
                      CBM
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "110px", minWidth: "110px" }} align="center">
                      T/CBM
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "70px", minWidth: "70px" }} align="center">
                      N.W
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "130px", minWidth: "130px" }} align="center">
                      G.W
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "180px", minWidth: "180px" }} align="start">
                      Status
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                      Notes
                    </TableCell>
                  </Box>
                  <Box>
                    <TableCell sx={{ width: "300px", minWidth: "300px" }} align="center">
                      Operations
                    </TableCell>
                  </Box>
                </TableRow>
              </TableHead>
              <TableBody style={{ display: "block" }}>
                {rows.map((vla, index) => (
                  <TableRow key={`${index}key`} sx={{ minWidth: "1000px" }}>
                    <Box style={{ overflowX: "auto" }}>
                      <TableCell sx={{ width: "100px", minWidth: "100px" }} align="center">
                        <input
                          id="item"
                          required
                          onChange={(e) => handleItemChange(e, index)}
                          value={customer + shopnumber2 + -+(index + 1)}
                          type="text"
                          style={{ width: "100px", minWidth: "100px" }}
                          className="form-control"
                          name="name"
                          placeholder="Our Item"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "100px", minWidth: "100px" }} align="center">
                        <input
                          id="item"
                          required
                          onChange={(e) => handleItemNumberChange(e, index)}
                          value={itemnumber[index]}
                          type="text"
                          style={{ width: "100px", minWidth: "100px" }}
                          className="form-control"
                          name="name"
                          placeholder="Item Number"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "100px", minWidth: "100px" }} align="start">
                        <input
                          required
                          id="photo"
                          type="file"
                          style={{ width: "100px", minWidth: "100px" }}
                          className="form-control"
                          name="name"
                          // placeholder="Photo"
                          onChange={(e) => handlePhotoChange(e, index)}
                          // value={photo[index]}
                        />
                      </TableCell>
                      {/* <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                        <img
                          src={photo[index]}
                          style={{ width: "100px", height: "100px" }}
                          alt=""
                        />
                      </TableCell> */}
                      <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                        <input
                          required
                          id="desc1"
                          type="text"
                          style={{ width: "150px", minWidth: "150px" }}
                          className="form-control"
                          name="name"
                          placeholder="Chinese"
                          onChange={(e) => handleDescChange(e, index)}
                          value={description1[index]}
                        />
                      </TableCell>
                      <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                        <input
                          required
                          type="text"
                          id="category"
                          style={{ width: "150px", minWidth: "150px" }}
                          className="form-control"
                          name="name"
                          placeholder="Material"
                          onChange={(e) => handleCategoryChange(e, index)}
                          value={category[index]}
                        />
                      </TableCell>
                      <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                        <input
                          required
                          id="desc2"
                          type="text"
                          style={{ width: "150px", minWidth: "150px" }}
                          className="form-control"
                          name="name"
                          placeholder="English"
                          onChange={(e) => handleDesc2Change(e, index)}
                          value={description2[index]}
                        />
                      </TableCell>

                      <TableCell sx={{ width: "60px", minWidth: "60px" }} align="start">
                        <input
                          required
                          type="text"
                          style={{ width: "60px", minWidth: "60px" }}
                          className="form-control"
                          name="name"
                          placeholder="CTN"
                          onChange={(e) => handleCTNChange(e, index)}
                          value={ctn[index]}
                          id="ctn"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "70px", minWidth: "70px" }} align="start">
                        <input
                          required
                          type="text"
                          style={{ width: "70px", minWidth: "70px" }}
                          className="form-control"
                          name="name"
                          placeholder="QTY/CTN"
                          onChange={(e) => handleQTYTOCTNChange(e, index)}
                          value={qtytoctn[index]}
                          id="qtytoctn"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "70px", minWidth: "70px" }} align="start">
                        <input
                          required
                          type="text"
                          style={{ width: "70px", minWidth: "70px" }}
                          className="form-control"
                          name="name"
                          readOnly
                          placeholder="T/QTY"
                          // onChange={(e) => handleTTOQTYChange(e, index)}
                          value={ttoqty[index]}
                          id="ttoqty"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "70px", minWidth: "70px" }} align="start">
                        <input
                          required
                          type="text"
                          style={{ width: "70px", minWidth: "70px" }}
                          className="form-control"
                          name="name"
                          placeholder="U/Price"
                          onChange={(e) => handleUTOPriceChange(e, index)}
                          value={utoprice[index]}
                          id="utoprice"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "80px", minWidth: "80px" }} align="start">
                        <input
                          required
                          type="text"
                          style={{ width: "80px", minWidth: "80px" }}
                          className="form-control"
                          name="name"
                          placeholder="Amount"
                          readOnly
                          // onChange={(e) => handleAmountChange(e, index)}
                          value={amount[index]}
                          // id="amount"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "60px", minWidth: "60px" }} align="start">
                        <input
                          required
                          type="text"
                          style={{ width: "60px", minWidth: "60px" }}
                          className="form-control"
                          name="name"
                          placeholder="CBM"
                          onChange={(e) => handleCBMChange(e, index)}
                          value={cbm[index]}
                          id="cbm"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "60px", minWidth: "60px" }} align="start">
                        <input
                          required
                          type="text"
                          style={{ width: "60px", minWidth: "60px" }}
                          className="form-control"
                          name="name"
                          placeholder="T/CBM"
                          readOnly
                          // onChange={(e) => handleTTOCBMChange(e, index)}
                          value={ttocbm[index]}
                          id="ttocbm"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "70px", minWidth: "70px" }} align="start">
                        <input
                          required
                          type="text"
                          style={{ width: "70px", minWidth: "70px" }}
                          className="form-control"
                          name="name"
                          placeholder="N.W"
                          onChange={(e) => handleNWChange(e, index)}
                          value={nw[index]}
                          id="nw"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "70px", minWidth: "70px" }} align="start">
                        <input
                          required
                          type="text"
                          style={{ width: "70px", minWidth: "70px" }}
                          className="form-control"
                          name="name"
                          placeholder="G.W"
                          readOnly
                          // onChange={(e) => handleGWChange(e, index)}
                          value={gw[index]}
                          id="gw"
                        />
                      </TableCell>
                      <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                        <select
                          id="customer_id"
                          onChange={(e) => handleStatusChange(e, index)}
                          className="form-control"
                          style={{ height: "40px" }}
                          value={status[index]}
                        >
                          {statusarray.map((user) => (
                            <option value={user.name}>{user.name}</option>
                          ))}
                        </select>
                      </TableCell>
                      <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                        <input
                          required
                          type="text"
                          style={{ width: "150px", minWidth: "150px" }}
                          className="form-control"
                          name="name"
                          placeholder="Notes"
                          onChange={(e) => handleNotesChange(e, index)}
                          value={notes[index]}
                          id="notes"
                        />
                      </TableCell>
                      <TableCell
                        sx={{ width: "400px", minWidth: "400px" }}
                        style={{ flexDirection: "row" }}
                        align="space-around"
                      >
                        <Button
                          variant="contained"
                          style={{
                            color: "white",
                            width: "100px",
                            minWidth: "100px",
                            fontSize: "10px",
                          }}
                          onClick={() => {
                            setItemArray((state) => [...state, ""]);
                            setItemNumber((state) => [...state, ""]);
                            setPhoto((state) => [...state, ""]);
                            setDescription1((state) => [...state, ""]);
                            setDescription2((state) => [...state, ""]);
                            setCategory((state) => [...state, ""]);
                            setCTN((state) => [...state, ""]);
                            setQtyToCtn((state) => [...state, ""]);
                            // setTtoQty((state) => [...state, ""]);
                            setUtoPrice((state) => [...state, ""]);
                            // setAmount((state) => [...state, ""]);
                            setCBM((state) => [...state, ""]);
                            // setTtoCBM((state) => [...state, ""]);
                            setNW((state) => [...state, ""]);
                            // setGW((state) => [...state, ""]);
                            setStatus((state) => [...state, ""]);
                            setNotes((state) => [...state, ""]);

                            setRows((current) => [...current, current.length]);
                          }}
                        >
                          Add Item
                        </Button>
                        <Button
                          variant="contained"
                          style={{
                            color: "white",
                            width: "120px",
                            fontSize: "10px",
                            marginLeft: "10px",
                          }}
                          onClick={() => {
                            setRows([...rows.slice(0, index), ...rows.slice(index + 1)]);
                            setItemArray((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            setItemNumber((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            setPhoto((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            setDescription1((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            setDescription1((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            setDescription2((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            setCategory((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            setCTN((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            setQtyToCtn((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            // setTtoQty((prevSate) => [
                            //   ...prevSate.slice(0, index),
                            //   ...prevSate.slice(index + 1),
                            // ]);
                            setUtoPrice((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            // setAmount((prevSate) => [
                            //   ...prevSate.slice(0, index),
                            //   ...prevSate.slice(index + 1),
                            // ]);
                            setCBM((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            // setTtoCBM((prevSate) => [
                            //   ...prevSate.slice(0, index),
                            //   ...prevSate.slice(index + 1),
                            // ]);
                            setNW((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            // setGW((prevSate) => [
                            //   ...prevSate.slice(0, index),
                            //   ...prevSate.slice(index + 1),
                            // ]);
                            setStatus((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                            setNotes((prevSate) => [
                              ...prevSate.slice(0, index),
                              ...prevSate.slice(index + 1),
                            ]);
                          }}
                        >
                          Remove Item
                        </Button>
                      </TableCell>
                    </Box>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </SuiBox>
        </Card>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddOrder;
